import getWindow from './getWindow';

export default function isDOMInstance<T extends Node>(
  node: unknown,
  // eslint-disable-next-line @typescript-eslint/ban-types
  type: Function = Node,
): node is T {
  if (node instanceof type) return true;
  const window = getWindow(node as Node);
  if (window) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    type = (window as unknown as Record<string, Function>)[type.name] || type;
  }
  return node instanceof type;
}
